<template>
  <RangedReports
    :reportData="reportData"
    :reportTotals="reportTotals"
    :chartData="chartData"
    :currentRange="year"
    :loading="$apollo.loading"
    :startDate="startDate"
    month
    @change="onYearSelect"
  />
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import dayjs from '@/dayjs';
import i18n from '@/i18n';
import { useLocationsStore } from '@/stores/locations';
import RangedReports from '../components/RangedReports.vue';

export default defineComponent({
  components: {
    RangedReports,
  },
  data() {
    return {
      startDate: dayjs().format(),
      monthlyReport: {},
      reportTotals: {},
      reportData: [],
      reportChartData: {},
    };
  },
  apollo: {
    monthlyReport: {
      query: gql`
        query monthlyReport(
          $startDate: DateTime
          $locationId: ID
          $dataScope: DataScope
        ) {
          monthlyReport(
            startDate: $startDate
            locationId: $locationId
            dataScope: $dataScope
          ) {
            data {
              date
              bank
              cash
              cheque
              coupon
              creditcard
              date
              discount
              giftcard
              online
              orders
              pin
              prepaidCard
              total
              totalInc
              transactions
              treatwellOnlinePayment
              vat
              pos
              other
              gifty
            }
            chartData {
              categories
              orders
              totals
            }
            totals {
              total
              totalBank
              totalCash
              totalCheque
              totalCoupon
              totalCreditcard
              totalGiftcard
              totalInc
              totalOnline
              totalOrders
              totalPin
              totalPrepaidCard
              totalTransactions
              totalTreatwellOnlinePayment
              totalPos
              totalOther
              totalGifty
              totalVat
            }
          }
        }
      `,
      variables() {
        return {
          startDate: this.startDate,
          locationId: this.locationId,
          dataScope: this.dataScope,
        };
      },
      result() {
        this.reportTotals = this.monthlyReport.totals;
        this.reportData = this.monthlyReport.data;
        this.reportChartData = this.monthlyReport.chartData;
      },
    },
  },
  computed: {
    ...mapState(useLocationsStore, ['locationId', 'dataScope']),
    year() {
      return dayjs(this.startDate).year();
    },
    chartData() {
      return {
        labels: this.reportChartData.categories,
        data: [this.reportChartData.orders, this.reportChartData.totals],
      };
    },
  },
  methods: {
    onYearSelect(date) {
      this.startDate = date.format();
    },
  },
});
</script>
